<template>
    <tbody :index="index">
        <!-- {{ inforBlock }} -->
        <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_DISPLAY_1 && isShowBlockOfPageConfirm">
            <tr>
                <td :class="`fm-answer`" colspan="2" :style="`${onHandleSetStyleAnswer(inforBlock)}; ${isDisableBorder ? 'border-style: none' : ''}`">
                    <div
                        v-html="convertHtmlLinks(inforBlock.label)"
                        :style="
                            isPageComplete
                                ? ''
                                : inforBlock.is_scroll_none
                                  ? ''
                                  : `max-height: ${inforBlock.custom_height ? inforBlock.custom_height : 300}px; overflow-y: auto`
                        "
                    ></div>
                </td>
            </tr>
        </template>

        <template v-if="formGroupLayout == 'row'">
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_DISPLAY_2 && isShowBlockOfPageConfirm">
                <tr>
                    <td :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`">
                            <div v-html="inforBlock?.block_div_2?.label_q"></div>
                        </div>
                    </td>
                    <td :class="`fm-answer text-${choicePlacement('answer')}`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <div v-html="inforBlock?.block_div_2?.label_a"></div>
                    </td>
                </tr>
            </template>
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_INPUT && onHandleShowBlockOfPageConfirm(inforBlock.block_type)">
                <tr :id="inforBlock.id">
                    <td :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                    <td :class="`fm-answer text-${choicePlacement('answer')}`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <template v-if="defineShowTypeBlock">
                            <div>
                                <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                                    <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                        <div
                                            v-if="inforBlock.additional_setting.note_left_block"
                                            v-html="inforBlock.additional_setting.note_left_block"
                                            class="note__left"
                                        />
                                        <div>
                                            <div class="d-flex align-items-center" :style="`justify-content:${choicePlacement('answer')}`">
                                                <InputText
                                                    :id="`InputText-Form-${indexInputText}-${index}-${inforBlock.id}`"
                                                    :model.sync="configBlock.modelInput[inforBlock.id]"
                                                    :config.sync="configBlock.validateInput[inforBlock.id].configField"
                                                    @change="inputAddress"
                                                    @blur="handleValidateField(inforBlock, configBlock.validateInput[inforBlock.id].configField)"
                                                    :disabled="disabled"
                                                />
                                                <span
                                                    class="text-nowrap"
                                                    :style="onHandleSetStyleLabel(settingConfirmLabel, 'confirm')"
                                                    style="opacity: 0; visibility: hidden"
                                                    >{{
                                                        settingConfirmLabel
                                                            ? settingConfirmLabel.label_required
                                                            : $t('managerForm.settingPage.confirmation')
                                                    }}</span
                                                >
                                            </div>
                                            <div
                                                v-if="inforBlock.block_input.confirm_input_twice == OPTION_YES_NO[0]?.id"
                                                class="mt-3 d-flex align-items-center"
                                                :style="`justify-content:${choicePlacement('answer')}`"
                                            >
                                                <InputText
                                                    :id="`InputText-Confirmation-${indexInputText}-${index}-${inforBlock.id}`"
                                                    :model.sync="configBlock.modelConfirmInput[inforBlock.id]"
                                                    :config.sync="configBlock.validateInput[inforBlock.id].configField"
                                                    @blur="handleValidateField(inforBlock, configBlock.validateInput[inforBlock.id].configField)"
                                                    :disabled="disabled"
                                                />
                                                <span class="text-nowrap" :style="onHandleSetStyleLabel(settingConfirmLabel, 'confirm')">{{
                                                    settingConfirmLabel
                                                        ? settingConfirmLabel.label_required
                                                        : $t('managerForm.settingPage.confirmation')
                                                }}</span>
                                            </div>
                                            <div
                                                v-if="configBlock.validateInput[inforBlock.id].configField.error"
                                                :class="`form__alert--error text-${choicePlacement('answer')}`"
                                            >
                                                {{ configBlock.validateInput[inforBlock.id].configField.errorField }}
                                            </div>
                                        </div>
                                        <div
                                            v-if="inforBlock.additional_setting.note_right_block"
                                            v-html="inforBlock.additional_setting.note_right_block"
                                            class="note__right"
                                        />
                                    </div>
                                    <div
                                        :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                        v-if="inforBlock.additional_setting.note_bottom_block"
                                        v-html="inforBlock.additional_setting.note_bottom_block"
                                    />
                                </div>
                            </div>
                        </template>
                        <div v-else>
                            {{ configBlock.modelInput[inforBlock.id] }}
                        </div>
                    </td>
                </tr>
            </template>
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_TEXTAREA && onHandleShowBlockOfPageConfirm(inforBlock.block_type)">
                <tr :id="inforBlock.id">
                    <td :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                    <td :class="`fm-answer`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <div v-if="defineShowTypeBlock" :style="`display: flex; justify-content:${choicePlacement('answer')}`">
                            <div class="d-flex flex-column w-100" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />
                                    <TextareaComponent
                                        :id="`InputText-Confirmation-${indexTextarea}-${index}-${inforBlock.id}`"
                                        :model.sync="configBlock.modelTextarea[inforBlock.id]"
                                        :cols="inforBlock.block_text_area.cols"
                                        :rows="inforBlock.block_text_area.rows"
                                        :config.sync="configBlock.validateTextarea[inforBlock.id].configField"
                                        :style="{
                                            width: !inforBlock.block_text_area.cols ? '100%' : 'auto',
                                            minWidth: !inforBlock.block_text_area.cols ? '95%' : 'auto'
                                        }"
                                        @blur="handleValidateField(inforBlock, configBlock.validateTextarea[inforBlock.id].configField)"
                                        :disabled="disabled"
                                    >
                                        <div
                                            v-if="configBlock.validateTextarea[inforBlock.id].configField.error"
                                            :class="`form__alert--error text-nowrap`"
                                        >
                                            <span>
                                                {{ configBlock.validateTextarea[inforBlock.id].configField.errorField }}
                                            </span>
                                        </div>
                                    </TextareaComponent>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                />
                            </div>
                        </div>
                        <div v-else v-html="textLineBreaks(configBlock.modelTextarea[inforBlock.id])"></div>
                    </td>
                </tr>
            </template>
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_DATE && onHandleShowBlockOfPageConfirm(inforBlock.block_type)">
                <tr :id="inforBlock.id">
                    <td :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                    <td :class="`fm-answer`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <template v-if="defineShowTypeBlock">
                            <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />
                                    <div>
                                        <div
                                            v-if="
                                                isShowDateFormType(
                                                    inforBlock.block_date.format_year.type,
                                                    inforBlock.block_date.format_month_day.type
                                                ) === 'inputDate'
                                            "
                                            :class="`d-flex`"
                                            :style="`justify-content:${choicePlacement('answer')}`"
                                        >
                                            <DateNormal
                                                :id="`DateForm-${inforBlock.id}-${index}-${indexDate}`"
                                                :full_date.sync="configBlock.modelDateForm[inforBlock.id].text"
                                                :config.sync="configBlock.validateDateForm[inforBlock.id].configField"
                                                @blur="handleValidateField(inforBlock, configBlock.validateDateForm[inforBlock.id].configField)"
                                                :disabled="disabled"
                                            >
                                            </DateNormal>
                                        </div>
                                        <div
                                            v-if="
                                                isShowDateFormType(
                                                    inforBlock.block_date.format_year.type,
                                                    inforBlock.block_date.format_month_day.type
                                                ) === 'selectDate'
                                            "
                                            class="d-flex align-items-center flex-nowrap"
                                            :style="`gap: 10px; justify-content:${choicePlacement('answer')}`"
                                        >
                                            <Multiselect
                                                :id="`YearDateForm-${inforBlock.id}-${index}-${indexDate}`"
                                                style="width: 80px"
                                                :value.sync="configBlock.modelDateForm[inforBlock.id].select.year"
                                                :options="yearOptions"
                                                :config.sync="configBlock.validateDateForm[inforBlock.id].configSelectYear"
                                                @select="handleSelectDate"
                                                :disabled="disabled"
                                            />
                                            <Multiselect
                                                :id="`MonthDateForm-${inforBlock.id}-${index}-${indexDate}`"
                                                style="width: 80px"
                                                :value.sync="configBlock.modelDateForm[inforBlock.id].select.month"
                                                :options="onHandleMergeOptionValues(MONTH_OPTIONS, inforBlock)"
                                                :config.sync="configBlock.validateDateForm[inforBlock.id].configSelectMonth"
                                                @select="handleSelectDate"
                                                :disabled="disabled"
                                            />
                                            <Multiselect
                                                :id="`DayDateForm-${inforBlock.id}-${index}-${indexDate}`"
                                                style="width: 80px"
                                                :value.sync="configBlock.modelDateForm[inforBlock.id].select.day"
                                                :options="onHandleMergeOptionValues(DAY_OPTIONS, inforBlock)"
                                                :config.sync="configBlock.validateDateForm[inforBlock.id].configSelectDay"
                                                @select="handleSelectDate"
                                                :disabled="disabled"
                                            />
                                        </div>
                                        <div
                                            v-if="configBlock.validateDateForm[inforBlock.id].configField.error"
                                            :class="`form__alert--error text-${choicePlacement('answer')}`"
                                        >
                                            <span>{{ configBlock.validateDateForm[inforBlock.id].configField.errorField }}</span>
                                        </div>
                                    </div>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                />
                            </div>
                        </template>
                        <div v-else>
                            <div
                                v-if="
                                    isShowDateFormType(inforBlock.block_date.format_year.type, inforBlock.block_date.format_month_day.type) ===
                                    'inputDate'
                                "
                            >
                                {{ formatDateCommon(configBlock.modelDateForm[inforBlock.id].text, 'dateJP') ?? '' }}
                            </div>
                            <div
                                v-if="
                                    isShowDateFormType(inforBlock.block_date.format_year.type, inforBlock.block_date.format_month_day.type) ===
                                    'selectDate'
                                "
                            >
                                {{ onHandleRenderDateTypeSelect(configBlock.modelDateForm[inforBlock.id].select) ?? '' }}
                            </div>
                        </div>
                    </td>
                </tr>
            </template>
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER && onHandleShowBlockOfPageConfirm(inforBlock.block_type)">
                <tr :id="inforBlock.id">
                    <td :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                    <td :class="`fm-answer`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <template v-if="defineShowTypeBlock">
                            <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />
                                    <div>
                                        <div
                                            class="d-flex align-items-center flex-nowrap"
                                            :style="`gap: 10px; justify-content:${choicePlacement('answer')}`"
                                        >
                                            <InputText
                                                :id="`InputPhone-1-Form-${inforBlock.id}-${index}-${indexPhone}`"
                                                :model.sync="configBlock.modelInputPhone_1[inforBlock.id]"
                                                style="min-width: 60px"
                                                :config.sync="configBlock.validateInputPhone_1[inforBlock.id].configField"
                                                @blur="handleValidateField(inforBlock, configBlock.validateInputPhone_1[inforBlock.id].configField)"
                                                :disabled="disabled"
                                            />
                                            <div class="p-1" style="font-size: 20px">-</div>
                                            <InputText
                                                :id="`InputPhone-2-Form-${inforBlock.id}-${index}-${indexPhone}`"
                                                :model.sync="configBlock.modelInputPhone_2[inforBlock.id]"
                                                style="min-width: 60px"
                                                :config.sync="configBlock.validateInputPhone_2[inforBlock.id].configField"
                                                @blur="handleValidateField(inforBlock, configBlock.validateInputPhone_2[inforBlock.id].configField)"
                                                :disabled="disabled"
                                            />
                                            <div class="p-1" style="font-size: 20px">-</div>
                                            <InputText
                                                :id="`InputPhone-3-Form-${inforBlock.id}-${index}-${indexPhone}`"
                                                :model.sync="configBlock.modelInputPhone_3[inforBlock.id]"
                                                style="min-width: 60px"
                                                :config.sync="configBlock.validateInputPhone_3[inforBlock.id].configField"
                                                @blur="handleValidateField(inforBlock, configBlock.validateInputPhone_3[inforBlock.id].configField)"
                                                :disabled="disabled"
                                            />
                                        </div>
                                        <div
                                            v-if="
                                                configBlock.validateInputPhone_1[inforBlock.id].configField.error ||
                                                configBlock.validateInputPhone_2[inforBlock.id].configField.error ||
                                                configBlock.validateInputPhone_3[inforBlock.id].configField.error
                                            "
                                            :class="`form__alert--error text-${choicePlacement('answer')}`"
                                        >
                                            {{ configBlock.validatePhoneCommon[inforBlock.id].configField.errorField }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                />
                            </div>
                        </template>
                        <div v-else>
                            {{
                                renderValueText(inforBlock.block_type, null, {
                                    modelPhoneNumber1: configBlock.modelInputPhone_1[inforBlock.id],
                                    modelPhoneNumber2: configBlock.modelInputPhone_2[inforBlock.id],
                                    modelPhoneNumber3: configBlock.modelInputPhone_3[inforBlock.id]
                                })
                            }}
                        </div>
                    </td>
                </tr>
            </template>
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_FULL_NAME && onHandleShowBlockOfPageConfirm(inforBlock.block_type)">
                <tr :id="inforBlock.id">
                    <td :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                    <td :class="`fm-answer text-${choicePlacement('answer')}`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <template v-if="defineShowTypeBlock">
                            <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />
                                    <div>
                                        <div
                                            class="d-flex align-items-center flex-nowrap"
                                            :style="`gap: 12px; justify-content:${choicePlacement('answer')}`"
                                        >
                                            <div class="d-flex mb-0 flex-nowrap">
                                                <label class="text-nowrap mt-2" style="min-width: 35px"
                                                    >{{ inforBlock?.input_format?.first_name }}
                                                </label>
                                                <InputText
                                                    style="min-width: 70px"
                                                    :id="`User-Last_Name-Form-${inforBlock.id}-${index}-${indexFullname}`"
                                                    :model.sync="configBlock.modelFirstName[inforBlock.id]"
                                                    :config.sync="configBlock.validateFirstName[inforBlock.id].configField"
                                                    @blur="handleValidateField(inforBlock, configBlock.validateFirstName[inforBlock.id].configField)"
                                                    :disabled="disabled"
                                                />
                                            </div>
                                            <div class="d-flex mb-0 flex-nowrap">
                                                <label class="text-nowrap mt-2" style="min-width: 35px"
                                                    >{{ inforBlock?.input_format?.last_name }}
                                                </label>
                                                <InputText
                                                    style="min-width: 70px"
                                                    :id="`User-First_Name-Form-${inforBlock.id}-${index}-${indexFullname}`"
                                                    :model.sync="configBlock.modelLastName[inforBlock.id]"
                                                    :config.sync="configBlock.validateLastName[inforBlock.id].configField"
                                                    @blur="handleValidateField(inforBlock, configBlock.validateLastName[inforBlock.id].configField)"
                                                    :disabled="disabled"
                                                />
                                            </div>
                                        </div>
                                        <div
                                            v-if="
                                                configBlock.validateFirstName[inforBlock.id].configField.error ||
                                                configBlock.validateLastName[inforBlock.id].configField.error
                                            "
                                            :class="`form__alert--error text-${choicePlacement('answer')}`"
                                        >
                                            {{ configBlock.validateFullnameCommon[inforBlock.id].configField.errorField }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                />
                            </div>
                        </template>
                        <div v-else>{{ configBlock.modelFirstName[inforBlock.id] }} {{ configBlock.modelLastName[inforBlock.id] }}</div>
                    </td>
                </tr>
            </template>
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE && onHandleShowBlockOfPageConfirm(inforBlock.block_type)">
                <tr :id="inforBlock.id">
                    <td :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                    <td :class="`fm-answer text-${choicePlacement('answer')}`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <template v-if="defineShowTypeBlock">
                            <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />
                                    <div>
                                        <div :class="`d-flex align-items-end`" :style="`gap: 12px; justify-content:${choicePlacement('answer')}`">
                                            <InputText
                                                style="min-width: 80px"
                                                class="post__code-1"
                                                :id="`PostCode-1-Form-${inforBlock.id}-${index}-${indexPostcode}`"
                                                :model.sync="configBlock.modelPostcode_1[inforBlock.id]"
                                                :config.sync="configBlock.validatePostcode_1[inforBlock.id].configField"
                                                @blur="handleValidateField(inforBlock, configBlock.validatePostcode_1[inforBlock.id].configField)"
                                                :disabled="disabled"
                                            />
                                            <div class="p-1" style="font-size: 20px">-</div>
                                            <InputText
                                                style="min-width: 80px"
                                                class="post__code-2"
                                                :id="`PostCode-2-Form-${inforBlock.id}-${index}-${indexPostcode}`"
                                                :model.sync="configBlock.modelPostcode_2[inforBlock.id]"
                                                :config.sync="configBlock.validatePostcode_2[inforBlock.id].configField"
                                                @blur="handleValidateField(inforBlock, configBlock.validatePostcode_2[inforBlock.id].configField)"
                                                :disabled="disabled"
                                            />
                                            <div v-if="inforBlock.block_post_code.feature_search_address == OPTION_YES_NO[0]?.id">
                                                <button
                                                    :disabled="configBlock.validatePostcodeCommon[inforBlock.id].configField.valueSync?.length < 7"
                                                    :class="`btn btn-light text-nowrap fill-postcode ${configBlock.validatePostcodeCommon[inforBlock.id].configField.valueSync?.length < 7 ? 'disabled_cursor' : ''}`"
                                                    @click="
                                                        handleSearchAddress(
                                                            `${configBlock.modelPostcode_1[inforBlock.id]}${configBlock.modelPostcode_2[inforBlock.id]}`
                                                        )
                                                    "
                                                >
                                                    <span>{{ $t('managerForm.settingPage.btnAddrSearch') }}</span>
                                                </button>
                                            </div>
                                        </div>
                                        <div
                                            v-if="
                                                configBlock.validatePostcode_1[inforBlock.id].configField.error ||
                                                configBlock.validatePostcode_2[inforBlock.id].configField.error ||
                                                configBlock.validatePostcodeCommon[inforBlock.id].configField.error
                                            "
                                            :class="`form__alert--error text-${choicePlacement('answer')}`"
                                        >
                                            {{ configBlock.validatePostcodeCommon[inforBlock.id].configField.errorField }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                />
                            </div>
                        </template>
                        <div v-else>
                            {{
                                renderValueText(inforBlock.block_type, {
                                    modelPostcode1: configBlock.modelPostcode_1[inforBlock.id],
                                    modelPostcode2: configBlock.modelPostcode_2[inforBlock.id]
                                })
                            }}
                        </div>
                    </td>
                </tr>
            </template>
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX && onHandleShowBlockOfPageConfirm(inforBlock.block_type)">
                <tr :id="inforBlock.id">
                    <td :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                    <td :class="`fm-answer text-${choicePlacement('answer')}`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <template v-if="defineShowTypeBlock">
                            <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />
                                    <div>
                                        <div class="d-flex align-items-center" :style="`justify-content:${choicePlacement('answer')}`">
                                            <InputText
                                                :style="`display: flex; justify-content:${choicePlacement('answer')}`"
                                                :id="`KeywordBox-Form-${inforBlock.id}-${index}-${indexKeywordBox}`"
                                                :model.sync="configBlock.modelKeywordBox[inforBlock.id]"
                                                :config.sync="configBlock.validateKeywordBox[inforBlock.id].configField"
                                                @blur="handleValidateField(inforBlock, configBlock.validateKeywordBox[inforBlock.id].configField)"
                                                :disabled="disabled"
                                            />
                                        </div>
                                        <div
                                            v-if="configBlock.validateKeywordBox[inforBlock.id].configField.error"
                                            :class="`form__alert--error text-${choicePlacement('answer')}`"
                                        >
                                            {{ configBlock.validateKeywordBox[inforBlock.id].configField.errorField }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                />
                            </div>
                        </template>
                        <div v-else>
                            {{ configBlock.modelKeywordBox[inforBlock.id] }}
                        </div>
                    </td>
                </tr>
            </template>
        </template>
        <template v-else>
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_DISPLAY_2 && isShowBlockOfPageConfirm">
                <tr>
                    <td colspan="2" :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" :class="`fm-answer text-${choicePlacement('answer')}`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <div v-html="textLineBreaks(inforBlock?.block_div_2?.label_a)"></div>
                    </td>
                </tr>
            </template>
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_INPUT && onHandleShowBlockOfPageConfirm(inforBlock.block_type)">
                <tr :id="inforBlock.id">
                    <td colspan="2" :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" :class="`fm-answer text-${choicePlacement('answer')}`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <template v-if="defineShowTypeBlock">
                            <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />

                                    <div>
                                        <div class="d-flex align-items-center" :style="`justify-content:${choicePlacement('answer')}`">
                                            <InputText
                                                :id="`InputText-Form-${indexInputText}-${index}-${inforBlock.id}`"
                                                :model.sync="configBlock.modelInput[inforBlock.id]"
                                                :config.sync="configBlock.validateInput[inforBlock.id].configField"
                                                @change="inputAddress"
                                                @blur="handleValidateField(inforBlock, configBlock.validateInput[inforBlock.id].configField)"
                                                :disabled="disabled"
                                            />
                                            <span
                                                class="text-nowrap"
                                                style="opacity: 0; visibility: hidden"
                                                :style="onHandleSetStyleLabel(settingConfirmLabel, 'confirm')"
                                                >{{
                                                    settingConfirmLabel
                                                        ? settingConfirmLabel.label_required
                                                        : $t('managerForm.settingPage.confirmation')
                                                }}</span
                                            >
                                        </div>
                                        <div
                                            v-if="inforBlock.block_input.confirm_input_twice == OPTION_YES_NO[0]?.id"
                                            class="mt-3 d-flex align-items-center"
                                            :style="`justify-content:${choicePlacement('answer')}`"
                                        >
                                            <InputText
                                                :style="`display: flex; justify-content:${choicePlacement('answer')}`"
                                                :id="`InputText-Confirmation-${indexInputText}-${index}-${inforBlock.id}`"
                                                :model.sync="configBlock.modelConfirmInput[inforBlock.id]"
                                                :config.sync="configBlock.validateInput[inforBlock.id].configField"
                                                @blur="handleValidateField(inforBlock, configBlock.validateInput[inforBlock.id].configField)"
                                                :disabled="disabled"
                                            />
                                            <span class="text-nowrap" :style="onHandleSetStyleLabel(settingConfirmLabel, 'confirm')">{{
                                                settingConfirmLabel ? settingConfirmLabel.label_required : $t('managerForm.settingPage.confirmation')
                                            }}</span>
                                        </div>
                                        <div
                                            v-if="configBlock.validateInput[inforBlock.id].configField.error"
                                            :class="`form__alert--error text-${choicePlacement('answer')}`"
                                        >
                                            {{ configBlock.validateInput[inforBlock.id].configField.errorField }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                />
                            </div>
                        </template>
                        <div v-else>
                            {{ configBlock.modelInput[inforBlock.id] }}
                        </div>
                    </td>
                </tr>
            </template>
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_TEXTAREA && onHandleShowBlockOfPageConfirm(inforBlock.block_type)">
                <tr :id="inforBlock.id">
                    <td colspan="2" :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" :class="`fm-answer`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <div v-if="defineShowTypeBlock" :style="`display: flex; justify-content:${choicePlacement('answer')}`">
                            <div class="d-flex flex-column w-100" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />
                                    <TextareaComponent
                                        :id="`InputText-Confirmation-${indexTextarea}-${index}-${inforBlock.id}`"
                                        :model.sync="configBlock.modelTextarea[inforBlock.id]"
                                        :cols="inforBlock.block_text_area.cols"
                                        :rows="inforBlock.block_text_area.rows"
                                        :config.sync="configBlock.validateTextarea[inforBlock.id].configField"
                                        :style="{
                                            width: !inforBlock.block_text_area.cols ? '100%' : 'auto',
                                            minWidth: !inforBlock.block_text_area.cols ? '95%' : 'auto'
                                        }"
                                        @blur="handleValidateField(inforBlock, configBlock.validateTextarea[inforBlock.id].configField)"
                                        :disabled="disabled"
                                    >
                                        <div
                                            v-if="configBlock.validateTextarea[inforBlock.id].configField.error"
                                            :class="`form__alert--error text-nowrap text-${choicePlacement('answer')}`"
                                        >
                                            <span>
                                                {{ configBlock.validateTextarea[inforBlock.id].configField.errorField }}
                                            </span>
                                        </div>
                                    </TextareaComponent>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                />
                            </div>
                        </div>
                        <div v-else v-html="textLineBreaks(configBlock.modelTextarea[inforBlock.id])"></div>
                    </td>
                </tr>
            </template>
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_DATE && onHandleShowBlockOfPageConfirm(inforBlock.block_type)">
                <tr :id="inforBlock.id">
                    <td colspan="2" :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" :class="`fm-answer`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <template v-if="defineShowTypeBlock">
                            <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />
                                    <div>
                                        <div
                                            v-if="
                                                isShowDateFormType(
                                                    inforBlock.block_date.format_year.type,
                                                    inforBlock.block_date.format_month_day.type
                                                ) === 'inputDate'
                                            "
                                            :class="`d-flex`"
                                            :style="`justify-content:${choicePlacement('answer')}`"
                                        >
                                            <DateNormal
                                                :id="`DateForm-${inforBlock.id}-${index}-${indexDate}`"
                                                :full_date.sync="configBlock.modelDateForm[inforBlock.id].text"
                                                :config.sync="configBlock.validateDateForm[inforBlock.id].configField"
                                                @blur="handleValidateField(inforBlock, configBlock.validateDateForm[inforBlock.id].configField)"
                                                :disabled="disabled"
                                            >
                                            </DateNormal>
                                        </div>
                                        <div
                                            v-if="
                                                isShowDateFormType(
                                                    inforBlock.block_date.format_year.type,
                                                    inforBlock.block_date.format_month_day.type
                                                ) === 'selectDate'
                                            "
                                            class="d-flex align-items-center flex-nowrap"
                                            :style="`gap: 10px; justify-content:${choicePlacement('answer')}`"
                                        >
                                            <Multiselect
                                                :id="`YearDateForm-${inforBlock.id}-${index}-${indexDate}`"
                                                style="width: 180px"
                                                :value.sync="configBlock.modelDateForm[inforBlock.id].select.year"
                                                :options="yearOptions"
                                                :config.sync="configBlock.validateDateForm[inforBlock.id].configSelectYear"
                                                @select="handleSelectDate"
                                                :disabled="disabled"
                                            />
                                            <Multiselect
                                                :id="`MonthDateForm-${inforBlock.id}-${index}-${indexDate}`"
                                                style="width: 180px"
                                                :value.sync="configBlock.modelDateForm[inforBlock.id].select.month"
                                                :options="onHandleMergeOptionValues(MONTH_OPTIONS, inforBlock)"
                                                :config.sync="configBlock.validateDateForm[inforBlock.id].configSelectMonth"
                                                @select="handleSelectDate"
                                                :disabled="disabled"
                                            />
                                            <Multiselect
                                                :id="`DayDateForm-${inforBlock.id}-${index}-${indexDate}`"
                                                style="width: 180px"
                                                :value.sync="configBlock.modelDateForm[inforBlock.id].select.day"
                                                :options="onHandleMergeOptionValues(DAY_OPTIONS, inforBlock)"
                                                :config.sync="configBlock.validateDateForm[inforBlock.id].configSelectDay"
                                                @select="handleSelectDate"
                                                :disabled="disabled"
                                            />
                                        </div>
                                        <div
                                            v-if="configBlock.validateDateForm[inforBlock.id].configField.error"
                                            :class="`form__alert--error text-${choicePlacement('answer')}`"
                                        >
                                            <span>{{ configBlock.validateDateForm[inforBlock.id].configField.errorField }}</span>
                                        </div>
                                    </div>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                />
                            </div>
                        </template>
                        <div v-else>
                            <div
                                v-if="
                                    isShowDateFormType(inforBlock.block_date.format_year.type, inforBlock.block_date.format_month_day.type) ===
                                    'inputDate'
                                "
                            >
                                {{ formatDateCommon(configBlock.modelDateForm[inforBlock.id].text, 'dateJP') ?? '' }}
                            </div>
                            <div
                                v-if="
                                    isShowDateFormType(inforBlock.block_date.format_year.type, inforBlock.block_date.format_month_day.type) ===
                                    'selectDate'
                                "
                            >
                                {{ onHandleRenderDateTypeSelect(configBlock.modelDateForm[inforBlock.id].select) ?? '' }}
                            </div>
                        </div>
                    </td>
                </tr>
            </template>
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER && onHandleShowBlockOfPageConfirm(inforBlock.block_type)">
                <tr :id="inforBlock.id">
                    <td colspan="2" :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" :class="`fm-answer`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <template v-if="defineShowTypeBlock">
                            <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />

                                    <div>
                                        <div class="d-flex" :style="`gap: 12px; justify-content:${choicePlacement('answer')}`">
                                            <InputText
                                                :id="`InputPhone-1-Form-${inforBlock.id}-${index}-${indexPhone}`"
                                                :model.sync="configBlock.modelInputPhone_1[inforBlock.id]"
                                                style="min-width: 60px"
                                                :config.sync="configBlock.validateInputPhone_1[inforBlock.id].configField"
                                                @blur="handleValidateField(inforBlock, configBlock.validateInputPhone_1[inforBlock.id].configField)"
                                                :disabled="disabled"
                                            />
                                            <div class="p-1" style="font-size: 20px">-</div>
                                            <InputText
                                                :id="`InputPhone-2-Form-${inforBlock.id}-${index}-${indexPhone}`"
                                                :model.sync="configBlock.modelInputPhone_2[inforBlock.id]"
                                                style="min-width: 60px"
                                                :config.sync="configBlock.validateInputPhone_2[inforBlock.id].configField"
                                                @blur="handleValidateField(inforBlock, configBlock.validateInputPhone_2[inforBlock.id].configField)"
                                                :disabled="disabled"
                                            />
                                            <div class="p-1" style="font-size: 20px">-</div>
                                            <InputText
                                                :id="`InputPhone-3-Form-${inforBlock.id}-${index}-${indexPhone}`"
                                                :model.sync="configBlock.modelInputPhone_3[inforBlock.id]"
                                                style="min-width: 60px"
                                                :config.sync="configBlock.validateInputPhone_3[inforBlock.id].configField"
                                                @blur="handleValidateField(inforBlock, configBlock.validateInputPhone_3[inforBlock.id].configField)"
                                                :disabled="disabled"
                                            />
                                        </div>
                                        <div
                                            v-if="
                                                configBlock.validateInputPhone_1[inforBlock.id].configField.error ||
                                                configBlock.validateInputPhone_2[inforBlock.id].configField.error ||
                                                configBlock.validateInputPhone_3[inforBlock.id].configField.error
                                            "
                                            :class="`form__alert--error text-${choicePlacement('answer')}`"
                                        >
                                            {{ configBlock.validatePhoneCommon[inforBlock.id].configField.errorField }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                />
                            </div>
                        </template>
                        <div v-else>
                            {{
                                renderValueText(inforBlock.block_type, null, {
                                    modelPhoneNumber1: configBlock.modelInputPhone_1[inforBlock.id],
                                    modelPhoneNumber2: configBlock.modelInputPhone_2[inforBlock.id],
                                    modelPhoneNumber3: configBlock.modelInputPhone_3[inforBlock.id]
                                })
                            }}
                        </div>
                    </td>
                </tr>
            </template>
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_FULL_NAME && onHandleShowBlockOfPageConfirm(inforBlock.block_type)">
                <tr :id="inforBlock.id">
                    <td colspan="2" :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" :class="`fm-answer text-${choicePlacement('answer')}`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <template v-if="defineShowTypeBlock">
                            <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />

                                    <div>
                                        <div class="d-flex" :style="`gap: 12px; justify-content:${choicePlacement('answer')}`">
                                            <div class="d-flex mb-0 flex-nowrap">
                                                <label class="text-nowrap mt-2" style="min-width: 35px"
                                                    >{{ inforBlock?.input_format?.first_name }}
                                                </label>
                                                <InputText
                                                    style="min-width: 70px"
                                                    :id="`User-Last_Name-Form-${inforBlock.id}-${index}-${indexFullname}`"
                                                    :model.sync="configBlock.modelFirstName[inforBlock.id]"
                                                    :config.sync="configBlock.validateFirstName[inforBlock.id].configField"
                                                    @blur="handleValidateField(inforBlock, configBlock.validateFirstName[inforBlock.id].configField)"
                                                    :disabled="disabled"
                                                />
                                            </div>
                                            <div class="d-flex mb-0 flex-nowrap">
                                                <label class="text-nowrap mt-2" style="min-width: 35px"
                                                    >{{ inforBlock?.input_format?.last_name }}
                                                </label>
                                                <InputText
                                                    style="min-width: 70px"
                                                    :id="`User-First_Name-Form-${inforBlock.id}-${index}-${indexFullname}`"
                                                    :model.sync="configBlock.modelLastName[inforBlock.id]"
                                                    :config.sync="configBlock.validateLastName[inforBlock.id].configField"
                                                    @blur="handleValidateField(inforBlock, configBlock.validateLastName[inforBlock.id].configField)"
                                                    :disabled="disabled"
                                                />
                                            </div>
                                        </div>
                                        <div
                                            v-if="
                                                configBlock.validateFirstName[inforBlock.id].configField.error ||
                                                configBlock.validateLastName[inforBlock.id].configField.error
                                            "
                                            :class="`form__alert--error text-${choicePlacement('answer')}`"
                                        >
                                            {{ configBlock.validateFullnameCommon[inforBlock.id].configField.errorField }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                    class="note__bottom"
                                />
                            </div>
                        </template>
                        <div v-else>{{ configBlock.modelFirstName[inforBlock.id] }} {{ configBlock.modelLastName[inforBlock.id] }}</div>
                    </td>
                </tr>
            </template>
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE && onHandleShowBlockOfPageConfirm(inforBlock.block_type)">
                <tr :id="inforBlock.id">
                    <td colspan="2" :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" :class="`fm-answer text-${choicePlacement('answer')}`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <template v-if="defineShowTypeBlock">
                            <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />

                                    <div>
                                        <div class="d-flex flex-row" :style="`gap: 12px; justify-content:${choicePlacement('answer')}`">
                                            <InputText
                                                :id="`PostCode-1-Form-${inforBlock.id}-${index}-${indexPostcode}`"
                                                :model.sync="configBlock.modelPostcode_1[inforBlock.id]"
                                                :config.sync="configBlock.validatePostcode_1[inforBlock.id].configField"
                                                @blur="handleValidateField(inforBlock, configBlock.validatePostcode_1[inforBlock.id].configField)"
                                                :disabled="disabled"
                                            />
                                            <div class="p-1" style="font-size: 20px">-</div>
                                            <InputText
                                                :id="`PostCode-2-Form-${inforBlock.id}-${index}-${indexPostcode}`"
                                                :model.sync="configBlock.modelPostcode_2[inforBlock.id]"
                                                :config.sync="configBlock.validatePostcode_2[inforBlock.id].configField"
                                                @blur="handleValidateField(inforBlock, configBlock.validatePostcode_2[inforBlock.id].configField)"
                                                :disabled="disabled"
                                            />
                                            <div v-if="inforBlock.block_post_code.feature_search_address == OPTION_YES_NO[0]?.id" class="ml-3">
                                                <button
                                                    :disabled="configBlock.validatePostcodeCommon[inforBlock.id].configField.valueSync?.length < 7"
                                                    :class="`btn btn-light text-nowrap ${configBlock.validatePostcodeCommon[inforBlock.id].configField.valueSync?.length < 7 ? 'disabled_cursor' : ''}`"
                                                    @click="
                                                        handleSearchAddress(
                                                            `${configBlock.modelPostcode_1[inforBlock.id]}${configBlock.modelPostcode_2[inforBlock.id]}`
                                                        )
                                                    "
                                                >
                                                    {{ $t('managerForm.settingPage.btnAddrSearch') }}
                                                </button>
                                            </div>
                                        </div>
                                        <div
                                            v-if="
                                                configBlock.validatePostcode_1[inforBlock.id].configField.error ||
                                                configBlock.validatePostcode_2[inforBlock.id].configField.error ||
                                                configBlock.validatePostcodeCommon[inforBlock.id].configField.error
                                            "
                                            :class="`form__alert--error text-${choicePlacement('answer')}`"
                                        >
                                            {{ configBlock.validatePostcodeCommon[inforBlock.id].configField.errorField }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                />
                            </div>
                        </template>
                        <div v-else>
                            {{
                                renderValueText(inforBlock.block_type, {
                                    modelPostcode1: configBlock.modelPostcode_1[inforBlock.id],
                                    modelPostcode2: configBlock.modelPostcode_2[inforBlock.id]
                                })
                            }}
                        </div>
                    </td>
                </tr>
            </template>
            <template v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX && onHandleShowBlockOfPageConfirm(inforBlock.block_type)">
                <tr :id="inforBlock.id">
                    <td colspan="2" :class="`mb-0 fm-question`" :style="onHandleSetStyleQuestion(inforBlock)">
                        <div :style="`justify-content:${choicePlacement('question')}`" class="d-flex align-items-center flex-wrap">
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position == 'before'"
                                class="pr-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                            <span v-html="textLineBreaks(inforBlock.label)"></span>
                            <span
                                v-if="inforBlock.order_required && defineShowTypeBlock && settingRequireLabel?.position != 'before'"
                                class="pl-1"
                                :style="onHandleSetStyleLabel(settingRequireLabel)"
                                >{{ settingRequireLabel ? settingRequireLabel.label_required : $t('common.fieldRequired') }}</span
                            >
                        </div>
                    </td>
                </tr>
                <tr>
                    <td colspan="2" :class="`fm-answer text-${choicePlacement('answer')}`" :style="onHandleSetStyleAnswer(inforBlock)">
                        <template v-if="defineShowTypeBlock">
                            <div class="d-flex flex-column" :class="`align-items-${choicePlacement('answer')}`">
                                <div class="d-flex content_block" :style="`justify-content:${choicePlacement('answer')}`">
                                    <div
                                        v-if="inforBlock.additional_setting.note_left_block"
                                        v-html="inforBlock.additional_setting.note_left_block"
                                        class="note__left"
                                    />

                                    <div>
                                        <div class="d-flex align-items-center" :style="`justify-content:${choicePlacement('answer')}`">
                                            <InputText
                                                :style="`display: flex; justify-content:${choicePlacement('answer')}`"
                                                :id="`KeywordBox-Form-${inforBlock.id}-${index}-${indexKeywordBox}`"
                                                :model.sync="configBlock.modelKeywordBox[inforBlock.id]"
                                                :config.sync="configBlock.validateKeywordBox[inforBlock.id].configField"
                                                @blur="handleValidateField(inforBlock, configBlock.validateKeywordBox[inforBlock.id].configField)"
                                                :disabled="disabled"
                                            />
                                        </div>
                                        <div
                                            v-if="configBlock.validateKeywordBox[inforBlock.id].configField.error"
                                            :class="`form__alert--error text-${choicePlacement('answer')}`"
                                        >
                                            {{ configBlock.validateKeywordBox[inforBlock.id].configField.errorField }}
                                        </div>
                                    </div>
                                    <div
                                        v-if="inforBlock.additional_setting.note_right_block"
                                        v-html="inforBlock.additional_setting.note_right_block"
                                        class="note__right"
                                    />
                                </div>
                                <div
                                    :class="`text-${choicePlacement('answer')} mt-2 note__bottom`"
                                    v-if="inforBlock.additional_setting.note_bottom_block"
                                    v-html="inforBlock.additional_setting.note_bottom_block"
                                />
                            </div>
                        </template>
                        <div v-else>
                            {{ configBlock.modelKeywordBox[inforBlock.id] }}
                        </div>
                    </td>
                </tr>
            </template>
        </template>

        <ModalCommon :id="`ListPostcodeModal`" :config="configModalLisPostCode">
            <div v-for="(itemPostcode, idx) in listPostCode" :key="idx">
                <InputRadio
                    :model.sync="radioPostCode"
                    :name="`RadioPostcode-${idx}`"
                    :id="`RadioPostcode-${idx}`"
                    :value="itemPostcode"
                    :label="`${onHandleRenderZipCode(itemPostcode.zip_code)} ${itemPostcode.prefecture}${itemPostcode.city}${itemPostcode.area}`"
                />
            </div>

            <div class="text-center mt-5">
                <button type="button" class="btn btn-primary ml-3" @click="handleChoicePostCode">
                    <span>
                        {{ $t('btn.save') }}
                    </span>
                </button>
            </div>
        </ModalCommon>
    </tbody>
</template>

<script>
import { renderLineBreaks, formatDateCommon, convertHtmlLinks } from '@/utils/format';
import { InputText, InputRadio } from '@/components/Input';
import { validateField } from '@/utils/validate';
import {
    matchingMessageBlocks,
    incrementIndex,
    generateYearList,
    DAY_OPTIONS,
    MONTH_OPTIONS,
    isShowDateFormType,
    onHandleMapCssForm,
    onHandleGetValueTextAlign,
    onHandleSetStyleLabel
} from '../handlers';
import { PAGE_TYPES } from '../../constants';
import { onHandleMergeOptionValues } from '../../handlers';
import { ALL_BLOCK_TYPE } from '@/config/constants';
import { OPTION_YES_NO, CONFIRMATION_PAGE_DISPLAY } from '../../components/setting-block-form/constants';
import { getAddressByZip, getPostCodeByAddress } from 'postcode-address-get';

import TextareaComponent from '@/components/Textarea/main.vue';
import DateNormal from '@/components/DateCustoms/DateNormal/main.vue';
import Multiselect from '@/components/Multiselect/main.vue';
import ModalCommon from '@/components/Modal/main.vue';

export default {
    name: 'CommonBlockText',
    components: {
        InputText,
        InputRadio,
        TextareaComponent,
        DateNormal,
        Multiselect,
        ModalCommon
    },
    props: {
        index: {
            type: Number,
            default: () => 0
        },
        inforBlock: {
            type: Object,
            default: () => null
        },
        provinceInfor: {
            type: Object,
            default: () => null
        },
        settingDesign: {
            type: Object,
            default: () => null
        },
        configBlock: {
            type: Object,
            default: () => null
        },
        conditionPageShow: {
            type: String,
            default: () => 'input'
        },
        pagePreview: {
            type: Boolean,
            default: () => false
        },
        disabled: {
            type: Boolean,
            default: () => false
        },
        settingRequireLabel: {
            type: Object,
            default: () => null
        },
        settingConfirmLabel: {
            type: Object,
            default: () => null
        }
    },
    computed: {
        formGroupLayout() {
            return this.inforBlock.layout == 'default'
                ? this.settingDesign.table_settings.question_layout === 'horizontal'
                    ? 'row'
                    : 'cols'
                : this.inforBlock.layout;
        },
        labelLayout() {
            return (
                ['row'].includes(this.inforBlock.layout) ||
                (this.inforBlock.layout === 'default' && this.settingDesign.table_settings.question_layout == 'horizontal')
            );
        },

        defineShowTypeBlock() {
            return [PAGE_TYPES._A[0], PAGE_TYPES._B[0], 'prize_serial'].includes(this.conditionPageShow);
        },

        isPageComplete() {
            return [PAGE_TYPES._I[2], PAGE_TYPES._A[2]].includes(this.conditionPageShow);
        },

        isDisableBorder() {
            return !this.inforBlock.is_border_display;
        },

        isShowBlockOfPageConfirm() {
            if (this.defineShowTypeBlock) return true;
            return this.inforBlock.confirmation_page_display == CONFIRMATION_PAGE_DISPLAY[0].id;
        },
        yearOptions() {
            return onHandleMergeOptionValues(
                generateYearList(
                    this.inforBlock.block_date.format_year.lower_limit,
                    this.inforBlock.block_date.format_year.upper_limit,
                    this.inforBlock.block_date.format_year.type_calendar
                ),
                this.inforBlock
            );
        },

        onHandleRenderClassBlockForLayoutRow() {
            return (positionChoice) => {
                if (positionChoice == 'right') {
                    return 'end';
                } else if (positionChoice == 'left') {
                    return 'start';
                } else {
                    return 'center';
                }
            };
        }
    },
    data() {
        return {
            ALL_BLOCK_TYPE: ALL_BLOCK_TYPE,
            OPTION_YES_NO: OPTION_YES_NO,
            MONTH_OPTIONS: MONTH_OPTIONS,
            DAY_OPTIONS: DAY_OPTIONS,
            propsIndex: this.index,
            indexInputText: 0,
            indexTextarea: 0,
            indexPhone: 0,
            indexFullname: 0,
            indexPostcode: 0,
            indexKeywordBox: 0,
            indexDate: 0,
            listPostCode: [],
            radioPostCode: null,
            configModalLisPostCode: {
                title: '',
                model: false,
                scrollable: true,
                hideFooter: true,
                centered: true,
                size: 'md',
                class: 'search-address-form'
            },
            tempDisabledValues: null // nơi lưu giá trị tạm
        };
    },
    methods: {
        onHandleMergeOptionValues,
        generateYearList,
        isShowDateFormType,
        onHandleMapCssForm,
        onHandleSetStyleLabel,
        formatDateCommon,
        getAddressByZip,
        getPostCodeByAddress,
        convertHtmlLinks,

        choicePlacement(type) {
            switch (type) {
                case 'question':
                    return this.inforBlock.choice_placement_specification_question === 'default'
                        ? onHandleGetValueTextAlign(this.settingDesign.table_settings.question_text_alignment.horizontal)
                        : this.inforBlock.choice_placement_specification_question;
                case 'answer':
                    return this.inforBlock.choice_placement_specification_answer === 'default'
                        ? onHandleGetValueTextAlign(this.settingDesign.table_settings.answer_text_alignment.horizontal)
                        : this.inforBlock.choice_placement_specification_answer;
            }
        },

        onHandleShowBlockOfPageConfirm(blockType) {
            const blockConfig = this.configBlock;
            const forIn = this.inforBlock;
            if (this.defineShowTypeBlock) return true;
            if (this.inforBlock.confirmation_page_display == CONFIRMATION_PAGE_DISPLAY[1].id) {
                switch (blockType) {
                    case ALL_BLOCK_TYPE.BLOCK_INPUT:
                        return blockConfig.modelInput[forIn.id] !== '';
                    case ALL_BLOCK_TYPE.BLOCK_TEXTAREA:
                        return blockConfig.modelTextarea[forIn.id] !== '';
                    case ALL_BLOCK_TYPE.BLOCK_DATE:
                        return (
                            blockConfig.modelDateForm[forIn.id].text !== '' ||
                            this.onHandleRenderDateTypeSelect(blockConfig.modelDateForm[forIn.id].select) !== ''
                        );
                    case ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER:
                        return (
                            this.renderValueText(forIn.block_type, null, {
                                modelPhoneNumber1: blockConfig.modelInputPhone_1[forIn.id],
                                modelPhoneNumber2: blockConfig.modelInputPhone_2[forIn.id],
                                modelPhoneNumber3: blockConfig.modelInputPhone_3[forIn.id]
                            }) !== ''
                        );
                    case ALL_BLOCK_TYPE.BLOCK_FULL_NAME:
                        return blockConfig.modelFirstName[forIn.id] !== '' && blockConfig.modelLastName[forIn.id] !== '';
                    case ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE:
                        return (
                            this.renderValueText(forIn.block_type, {
                                modelPostcode1: blockConfig.modelPostcode_1[forIn.id],
                                modelPostcode2: blockConfig.modelPostcode_2[forIn.id]
                            }) !== ''
                        );
                    case ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX:
                        return blockConfig.modelKeywordBox[forIn.id] !== '';
                }
            }
            return true;
        },

        textLineBreaks(text) {
            return renderLineBreaks(text);
        },

        handleSelectDate() {
            let { year, month, day } = this.configBlock.modelDateForm[this.inforBlock.id].select;
            this.configBlock.validateDateForm[this.inforBlock.id].configField.valueSync =
                year.value || month.value || day.value ? `${year.value}-${month.value}-${day.value}` : '';
            validateField(this.configBlock.validateDateForm[this.inforBlock.id].configField);
            this.handleValidateField(this.inforBlock, this.configBlock.validateDateForm[this.inforBlock.id].configField);
            this.indexDate = incrementIndex(this.indexDate);
        },

        handleValidateField(blockInfor, configField) {
            const blockType = blockInfor?.block_type ?? '';
            if (blockType === ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE) {
                const modelPostcode1 = this.configBlock.modelPostcode_1[blockInfor.id]?.toString() || '';
                const modelPostcode2 = this.configBlock.modelPostcode_2[blockInfor.id]?.toString() || '';
                this.configBlock.validatePostcodeCommon[blockInfor.id].configField.valueSync =
                    modelPostcode1 || modelPostcode2 ? `${modelPostcode1}${modelPostcode2}` : '';
            } else if (blockType === ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER) {
                const modelPhone1 = this.configBlock.modelInputPhone_1[blockInfor.id]?.toString() || '';
                const modelPhone2 = this.configBlock.modelInputPhone_2[blockInfor.id]?.toString() || '';
                const modelPhone3 = this.configBlock.modelInputPhone_3[blockInfor.id]?.toString() || '';
                this.configBlock.validatePhoneCommon[blockInfor.id].configField.valueSync = `${modelPhone1}${modelPhone2}${modelPhone3}`;
            } else if (blockType === ALL_BLOCK_TYPE.BLOCK_FULL_NAME) {
                const valueFirstName = this.configBlock.modelFirstName[blockInfor.id] || '';
                const valueLastName = this.configBlock.modelLastName[blockInfor.id] || '';
                this.configBlock.validateFullnameCommon[blockInfor.id].configField.valueSync =
                    valueFirstName && valueLastName ? `${valueFirstName}${valueLastName}` : '';
            }
            validateField(configField);
            if (
                [
                    ALL_BLOCK_TYPE.BLOCK_INPUT,
                    ALL_BLOCK_TYPE.BLOCK_TEXTAREA,
                    ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER,
                    ALL_BLOCK_TYPE.BLOCK_FULL_NAME,
                    ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE,
                    ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX,
                    ALL_BLOCK_TYPE.BLOCK_DATE
                ].includes(blockType)
            ) {
                matchingMessageBlocks(this.configBlock, [], blockInfor);
            }

            switch (blockType) {
                case ALL_BLOCK_TYPE.BLOCK_INPUT:
                    this.indexInputText = incrementIndex(this.indexInputText);
                    break;
                case ALL_BLOCK_TYPE.BLOCK_TEXTAREA:
                    this.indexTextarea = incrementIndex(this.indexTextarea);
                    break;
                case ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER:
                    this.indexPhone = incrementIndex(this.indexPhone);
                    break;
                case ALL_BLOCK_TYPE.BLOCK_FULL_NAME:
                    this.indexFullname = incrementIndex(this.indexFullname);
                    break;
                case ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE:
                    this.indexPostcode = incrementIndex(this.indexPostcode);
                    break;
                case ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX:
                    this.indexKeywordBox = incrementIndex(this.indexKeywordBox);
                    break;
                case ALL_BLOCK_TYPE.BLOCK_DATE:
                    this.indexDate = incrementIndex(this.indexDate);
                    break;
            }
            this.$emit('emitBlurField');
        },

        onHandleRenderDateTypeSelect(dataSelect) {
            return dataSelect.year?.label && dataSelect.month?.label && dataSelect.day?.label
                ? `${dataSelect.year?.label}${dataSelect.month?.label}${dataSelect.day?.label}`
                : '';
        },

        renderValueText(typeBlock, valuePostcode, valuePhone) {
            switch (typeBlock) {
                case ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE:
                    return valuePostcode?.modelPostcode1 && valuePostcode?.modelPostcode2
                        ? `${valuePostcode.modelPostcode1}-${valuePostcode.modelPostcode2}`
                        : '';
                case ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER:
                    return valuePhone?.modelPhoneNumber1 && valuePhone?.modelPhoneNumber2 && valuePhone?.modelPhoneNumber3
                        ? `${valuePhone.modelPhoneNumber1}-${valuePhone.modelPhoneNumber2}-${valuePhone.modelPhoneNumber3}`
                        : '';
            }
        },

        handleSearchAddress(valuePostcode) {
            if (valuePostcode && !this.pagePreview) return;
            const PostcodeValidate_1 = this.configBlock.validatePostcode_1[this.inforBlock.id].configField;
            const PostcodeValidate_2 = this.configBlock.validatePostcode_2[this.inforBlock.id].configField;
            const PostcodeValidateCommon = this.configBlock.validatePostcodeCommon[this.inforBlock.id].configField;
            PostcodeValidate_1.error = false;
            PostcodeValidate_2.error = false;
            PostcodeValidateCommon.error = false;
            PostcodeValidate_1.isAddressNotFound = false;
            PostcodeValidate_2.isAddressNotFound = false;
            PostcodeValidateCommon.isAddressNotFound = false;
            if (valuePostcode.length < 7) return;
            this.onZipChange(valuePostcode, PostcodeValidate_1, PostcodeValidate_2, PostcodeValidateCommon);
        },

        async onZipChange(zip, GpostcodeValidate_1, GpostcodeValidate_2, GpostcodeValidateCommon) {
            const res = await fetch(`https://geoapi.heartrails.com/api/json?method=searchByPostal&postal=${zip}`);
            const data = await res.json();
            const dataLocation = data.response.location;
            let formatAddress = null;
            if (data.response?.error || dataLocation.length === 0) {
                GpostcodeValidate_1.isAddressNotFound = true;
                GpostcodeValidate_2.isAddressNotFound = true;
                GpostcodeValidateCommon.isAddressNotFound = true;
                this.handleValidateField(this.inforBlock, GpostcodeValidate_1);
                this.handleValidateField(this.inforBlock, GpostcodeValidate_2);
                this.propsIndex = incrementIndex(this.propsIndex);
                return;
            }
            if (dataLocation.length === 1) {
                const dataOne = dataLocation[0];
                formatAddress = {
                    prefecture: dataOne.prefecture,
                    city: dataOne.city,
                    area: dataOne.town
                };
                this.onHandleSetAddressFormPostCode(formatAddress);
                GpostcodeValidate_1.isAddressNotFound = false;
                GpostcodeValidate_2.isAddressNotFound = false;
                GpostcodeValidateCommon.isAddressNotFound = false;
            } else {
                this.listPostCode = dataLocation.map((postcodeItem) => {
                    return {
                        prefecture: postcodeItem.prefecture,
                        city: postcodeItem.city,
                        area: postcodeItem.town,
                        zip_code: postcodeItem.postal
                    };
                });
                this.radioPostCode = this.listPostCode[0];
                this.configModalLisPostCode.model = true;
            }
            this.handleValidateField(this.inforBlock, GpostcodeValidate_1);
            this.handleValidateField(this.inforBlock, GpostcodeValidate_2);
        },

        handleChoicePostCode() {
            this.onHandleSetAddressFormPostCode(this.radioPostCode);
            this.configModalLisPostCode.model = false;
        },

        onHandleSetAddressFormPostCode(address) {
            let { prefecture_insertion, city_insertion, town_area_name_insertion } = this.inforBlock.block_post_code;
            const modelInputSet = this.configBlock.modelInput;
            const validateInputSet = this.configBlock.validateInput;
            if (!prefecture_insertion?.id && !city_insertion?.id && !town_area_name_insertion?.id) return;
            if (prefecture_insertion?.id) {
                this.$emit('getAddress', { ...address, id_select_province: prefecture_insertion.id });
            }
            if (prefecture_insertion?.id == city_insertion?.id && city_insertion?.id == town_area_name_insertion?.id) {
                modelInputSet[city_insertion?.id] = `${address.prefecture}${address.city}${address.area}`;
                validateInputSet[city_insertion?.id].configField.error = false;
            } else if (prefecture_insertion?.id == city_insertion?.id) {
                modelInputSet[prefecture_insertion?.id] = `${address.prefecture}${address.city}`;
                modelInputSet[town_area_name_insertion?.id] = address.area;
                validateInputSet[town_area_name_insertion?.id].configField.error = false;
            } else if (city_insertion?.id == town_area_name_insertion?.id) {
                modelInputSet[city_insertion?.id] = `${address.city}${address.area}`;
                modelInputSet[prefecture_insertion?.id] = address.prefecture;
                if (validateInputSet[prefecture_insertion?.id]) validateInputSet[prefecture_insertion?.id].configField.error = false;
            } else if (prefecture_insertion?.id == town_area_name_insertion?.id) {
                modelInputSet[prefecture_insertion?.id] = `${address.prefecture}${address.area}`;
                modelInputSet[city_insertion?.id] = address.city;
                validateInputSet[city_insertion?.id].configField.error = false;
            } else {
                modelInputSet[prefecture_insertion?.id] = address.prefecture;
                modelInputSet[city_insertion?.id] = address.city;
                modelInputSet[town_area_name_insertion?.id] = address.area;
                if (validateInputSet[prefecture_insertion?.id]) validateInputSet[prefecture_insertion?.id].configField.error = false;
                validateInputSet[city_insertion?.id].configField.error = false;
                validateInputSet[town_area_name_insertion?.id].configField.error = false;
            }
            this.propsIndex = incrementIndex(this.propsIndex);
        },

        inputAddress() {
            // this.onHandleGetPostCodeByAddress();
        },

        async onHandleGetPostCodeByAddress(dataSelectProvince = null) {
            let { prefecture_insertion, city_insertion, town_area_name_insertion, id_input_post_code } = this.inforBlock.block_input;
            const idShowPCT = dataSelectProvince?.block_select_province?.id_input_post_code ?? id_input_post_code;
            const modelInputSearch = this.configBlock.modelInput;
            let query_code_post = '';
            if (!dataSelectProvince) {
                if (prefecture_insertion?.id === city_insertion?.id && city_insertion?.id === town_area_name_insertion?.id) {
                    query_code_post = `${modelInputSearch[prefecture_insertion?.id]}`;
                } else if (prefecture_insertion?.id == city_insertion?.id) {
                    query_code_post = `${modelInputSearch[prefecture_insertion?.id]}${modelInputSearch[city_insertion?.id]}`;
                } else if (city_insertion?.id == town_area_name_insertion?.id) {
                    query_code_post = `${modelInputSearch[city_insertion?.id]}${modelInputSearch[town_area_name_insertion?.id]}`;
                } else if (prefecture_insertion?.id == town_area_name_insertion?.id) {
                    query_code_post = `${modelInputSearch[prefecture_insertion?.id]}${modelInputSearch[town_area_name_insertion?.id]}`;
                }
            } else {
                query_code_post = `${dataSelectProvince.value}${modelInputSearch[dataSelectProvince.block_select_province?.city_insertion?.id]}`;
            }
            const res = await fetch(`https://geoapi.heartrails.com/api/json?method=suggest&matching=suffix&keyword=${query_code_post}`);
            const data = await res.json();
            if (data?.response?.location?.length > 0) {
                this.configBlock.modelPostcode_1[idShowPCT] = data.response?.location[0].postal.slice(0, 3);
                this.configBlock.modelPostcode_2[idShowPCT] = data.response?.location[0].postal.slice(3);
                this.propsIndex = incrementIndex(this.propsIndex);
            }
        },

        onHandleRenderZipCode(zipCode) {
            if (!zipCode) return '';
            return zipCode.slice(0, 3) + '-' + zipCode.slice(3);
        },

        onHandleSetStyleQuestion(blockInfor) {
            return `${
                blockInfor.cell_background_color.is_bg_question_default ? '' : `background-color:${blockInfor?.cell_background_color?.bg_question}`
            } `;
        },

        onHandleSetStyleAnswer(blockInfor) {
            return `${
                blockInfor.cell_background_color.is_bg_answer_default ? '' : `background-color:${blockInfor?.cell_background_color?.bg_answer}`
            } `;
        }
    },
    watch: {
        index: {
            handler(newIndex) {
                this.propsIndex = newIndex;
            },
            immediate: true
        },
        propsIndex: {
            handler(newPropsIndex) {
                this.$emit('update:index', newPropsIndex);
            },
            immediate: true
        },

        provinceInfor: {
            handler(newProvinceInfor) {
                if (!newProvinceInfor) return;
                // this.onHandleGetPostCodeByAddress(newProvinceInfor);
            },
            immediate: true,
            deep: true
        },

        settingDesign: {
            handler() {
                if (!this.settingDesign) return;
                onHandleMapCssForm(this.settingDesign);
            },
            immediate: true
        },
        disabled: {
            handler(newDisabled) {
                // đảm bảo object tempDisabledValues[modelKey] tồn tại
                if (!this.tempDisabledValues) {
                    this.tempDisabledValues = JSON.parse(JSON.stringify(this.configBlock));
                }
                switch (this.inforBlock.block_type) {
                    case ALL_BLOCK_TYPE.BLOCK_INPUT:
                        if (newDisabled) {
                            this.tempDisabledValues = JSON.parse(JSON.stringify(this.configBlock));
                            this.configBlock.modelInput[this.inforBlock.id] = '';
                            this.configBlock.modelConfirmInput[this.inforBlock.id] = '';
                            this.configBlock.validateInput[this.inforBlock.id].configField.error = false;
                        } else {
                            this.configBlock.modelInput[this.inforBlock.id] = this.tempDisabledValues.modelInput[this.inforBlock.id];
                            this.configBlock.modelConfirmInput[this.inforBlock.id] = this.tempDisabledValues.modelConfirmInput[this.inforBlock.id];
                        }
                        break;
                    case ALL_BLOCK_TYPE.BLOCK_TEXTAREA:
                        if (newDisabled) {
                            this.tempDisabledValues = JSON.parse(JSON.stringify(this.configBlock));
                            this.configBlock.modelTextarea[this.inforBlock.id] = '';
                            this.configBlock.validateTextarea[this.inforBlock.id].configField.error = false;
                        } else {
                            this.configBlock.modelTextarea[this.inforBlock.id] = this.tempDisabledValues.modelTextarea[this.inforBlock.id];
                        }
                        break;
                    case ALL_BLOCK_TYPE.BLOCK_PHONE_NUMBER:
                        if (newDisabled) {
                            this.tempDisabledValues = JSON.parse(JSON.stringify(this.configBlock));
                            this.configBlock.modelInputPhone_1[this.inforBlock.id] = '';
                            this.configBlock.modelInputPhone_2[this.inforBlock.id] = '';
                            this.configBlock.modelInputPhone_3[this.inforBlock.id] = '';
                            this.configBlock.validateInputPhone_1[this.inforBlock.id].configField.error = false;
                            this.configBlock.validateInputPhone_2[this.inforBlock.id].configField.error = false;
                            this.configBlock.validateInputPhone_3[this.inforBlock.id].configField.error = false;
                        } else {
                            this.configBlock.modelInputPhone_1[this.inforBlock.id] = this.tempDisabledValues.modelInputPhone_1[this.inforBlock.id];
                            this.configBlock.modelInputPhone_2[this.inforBlock.id] = this.tempDisabledValues.modelInputPhone_2[this.inforBlock.id];
                            this.configBlock.modelInputPhone_3[this.inforBlock.id] = this.tempDisabledValues.modelInputPhone_3[this.inforBlock.id];
                        }
                        break;
                    case ALL_BLOCK_TYPE.BLOCK_FULL_NAME:
                        if (newDisabled) {
                            this.tempDisabledValues = JSON.parse(JSON.stringify(this.configBlock));
                            this.configBlock.modelFirstName[this.inforBlock.id] = '';
                            this.configBlock.modelLastName[this.inforBlock.id] = '';
                            this.configBlock.validateFirstName[this.inforBlock.id].configField.error = false;
                            this.configBlock.validateLastName[this.inforBlock.id].configField.error = false;
                        } else {
                            this.configBlock.modelFirstName[this.inforBlock.id] = this.tempDisabledValues.modelFirstName[this.inforBlock.id];
                            this.configBlock.modelLastName[this.inforBlock.id] = this.tempDisabledValues.modelLastName[this.inforBlock.id];
                        }
                        break;
                    case ALL_BLOCK_TYPE.BLOCK_POSTAL_CODE:
                        if (newDisabled) {
                            this.tempDisabledValues = JSON.parse(JSON.stringify(this.configBlock));
                            this.configBlock.modelPostcode_1[this.inforBlock.id] = '';
                            this.configBlock.modelPostcode_2[this.inforBlock.id] = '';
                            this.configBlock.validatePostcode_1[this.inforBlock.id].configField.error = false;
                            this.configBlock.validatePostcode_2[this.inforBlock.id].configField.error = false;
                        } else {
                            this.configBlock.modelPostcode_1[this.inforBlock.id] = this.tempDisabledValues.modelPostcode_1[this.inforBlock.id];
                            this.configBlock.modelPostcode_2[this.inforBlock.id] = this.tempDisabledValues.modelPostcode_2[this.inforBlock.id];
                        }
                        break;
                    case ALL_BLOCK_TYPE.BLOCK_KEYWORD_BOX:
                        if (newDisabled) {
                            this.tempDisabledValues = JSON.parse(JSON.stringify(this.configBlock));
                            this.configBlock.modelKeywordBox[this.inforBlock.id] = '';
                            this.configBlock.validateKeywordBox[this.inforBlock.id].configField.error = false;
                        } else {
                            this.configBlock.modelKeywordBox[this.inforBlock.id] = this.tempDisabledValues.modelKeywordBox[this.inforBlock.id];
                        }
                        break;
                    case ALL_BLOCK_TYPE.BLOCK_DATE:
                        if (newDisabled) {
                            this.tempDisabledValues = JSON.parse(JSON.stringify(this.configBlock));
                            this.configBlock.modelDateForm[this.inforBlock.id].select = { year: '', month: '', day: '' };
                            this.configBlock.modelDateForm[this.inforBlock.id].text = '';
                            this.configBlock.validateDateForm[this.inforBlock.id].configField.error = false;
                            this.configBlock.validateDateForm[this.inforBlock.id].configSelectDay.error = false;
                            this.configBlock.validateDateForm[this.inforBlock.id].configSelectMonth.error = false;
                            this.configBlock.validateDateForm[this.inforBlock.id].configSelectYear.error = false;
                        } else {
                            this.configBlock.modelDateForm[this.inforBlock.id].select =
                                this.tempDisabledValues.modelDateForm[this.inforBlock.id].select;
                            this.configBlock.modelDateForm[this.inforBlock.id].text = this.tempDisabledValues.modelDateForm[this.inforBlock.id].text;
                        }
                        break;
                    default:
                        break;
                }
            }
        }
    },
    mounted() {}
};
</script>

<style lang="scss">
.fm-answer,
.fm-question {
    & img {
        max-width: 100%;
        height: auto !important;
    }
}
</style>
